import { Notebook } from "lucide-react";
import { useModal } from "../../../ModalContext";
import PastHistory from "../../../../DownloadPage/PastHistory"

const ReflectionHistory = () => {
    const { openModal, closeModal } = useModal();

  const handleOpenPastChats = () => {
    openModal(<PastHistory onClose={closeModal} />);
  };

  return (
    <div className="relative w-[356px] h-[407px] bg-gray flex flex-col justify-center items-center text-gray-500 overflow-hidden">
      {/* Main content */}

      {/* Floating Notebook button */}
      <button
        onClick={handleOpenPastChats}
        className="absolute bottom-5 right-5 w-10 h-10 rounded-full bg-[#54B0AF] hover:bg-[#459E9D]
                   text-white flex items-center justify-center shadow-[0_2px_6px_rgba(0,0,0,0.2)] transition-all duration-200"
        aria-label="View Reflection History"
      >
        <Notebook className="w-5 h-5" />
      </button>
    </div>
  );
};

export default ReflectionHistory;
